import classNames from "classnames";
import {
  ActionChip,
  ServiceIcon,
  SkeletonText,
  Text,
} from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

import { App } from "../types";

import getAppIconUrl from "./getAppIconUrl";
import styles from "./AppList.module.css";

export function AppList({
  apps,
  handleAppClick,
  isLoading,
  title,
  numOfAppsToShow,
  isDarkMode,
}: {
  apps: App[];
  handleAppClick: (app: App) => void;
  isLoading?: boolean;
  title: string;
  numOfAppsToShow: number;
  isDarkMode: boolean;
}) {
  return (
    <div>
      <div>
        <Text
          type="MinimalPrint2"
          color={isDarkMode ? "TextInverted" : "TextWeakest"}
        >
          {title}
        </Text>
      </div>
      <div className={styles.appList}>
        {isLoading ? (
          <SkeletonText
            lines={numOfAppsToShow}
            size="body"
            textAlign="left"
            width="100%"
            color={isDarkMode ? "GrayWarm7" : "GrayWarm2"}
          />
        ) : (
          apps.map((app) => {
            return (
              <div
                data-testid={`app-picker-app-${app.name}`}
                key={app.id}
                className={classNames({
                  [styles.actionChipWrapper]: !isDarkMode,
                  [styles.actionChipWrapperDarkMode]: isDarkMode,
                })}
              >
                <ActionChip onPress={() => handleAppClick(app)}>
                  {app.name === "Zap" ? (
                    <Icon
                      name="miscBoltAltFill"
                      color="BrandOrange"
                      size={20}
                    />
                  ) : (
                    <ServiceIcon
                      alt={`${app.name} icon`}
                      hasBorder={false}
                      size="xx-small"
                      hasWhiteBackground={false}
                      hasShadow={false}
                      serviceName={app.name}
                      src={getAppIconUrl(
                        app.currentImplementation?.id,
                        app?.images,
                        "xx-small",
                      )}
                    />
                  )}
                  <span className={classNames(styles.truncateText)}>
                    {app.name}
                  </span>
                </ActionChip>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
